(function () {
    'use strict';

    angular.module("imApp").factory("customerInvoicingsService", ['$ihttp', function ($ihttp) {
        let service = {
            getCustomerInvoicings: function (parms) {
                return $ihttp.post({
                    method: 2189,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
